import { render, staticRenderFns } from "./ListVerticalConfiguration.vue?vue&type=template&id=2cf685d7&"
import script from "./ListVerticalConfiguration.vue?vue&type=script&lang=js&"
export * from "./ListVerticalConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports